import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=04a6418e&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=04a6418e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6418e",
  null
  
)

export default component.exports